<script>
  import { onMount } from "svelte";
  import { writable } from "svelte/store";
  import { getUser, userLogin, lastWedding } from "../user.js";
  import { navigate } from "../router";
  import { showSignUp, showLogin } from "../event.js";
  import { querystring } from "../router";
  import { extractParams } from "../utils.js";
  import { check, join, isJoined } from "../wedding.js";

  import SignUp from "./SignUp.svelte";
  import JoinWithSignUp from "./JoinWithSignUp.svelte";

  let joinWedding = false;
  let logged = false;
  let verified = false;
  let signup_step = 1;
  let email = null;

  let code;
  let wedding_code;
  let invitation_code;
  let wedding = writable(undefined);

  let isLogin = $userLogin != "";

  let underConstruction = false;
  let canSignUp = false;
  let canJoin = true;
  let bapteme = false;

  const onCreateWedding = () => {
    if (canSignUp) {
      showSignUp.set(true);
    }
  };
  const onJoinWedding = () => {
    if (canJoin) {
      showSignUp.set(false);
      joinWedding = true;
    }
  };

  function onCloseSignUp() {
    showSignUp.set(false);
    signup_step = 1;
  }

  $: console.log("logged", logged, email, verified);

  let userRequest = getUser();

  onMount(async () => {
    let codes = extractParams("code", $querystring);
    if (codes) {
      codes = window.atob(codes);
      codes = codes.split("/");
      wedding_code = codes[0];
      invitation_code = codes[1];
    }

    bapteme = extractParams("b", $querystring, true);
    console.log("on mount BannerContent", wedding_code, invitation_code, bapteme);

    $userRequest
      .then(async (r) => {
        logged = true;
        email = r.data.login;
        verified = r.data.verified === "1";

        // si le compte n'est pas verifie on reprend le workflow signup
        if (!verified) {
          isLogin = false;
          if (r.data.code) {
            let w = await check(r.data.code);
            wedding.set(w.data);
            //console.log($wedding);

            signup_step = 3;
            joinWedding = true;
          } else {
            signup_step = 2;
            showSignUp.set(true);
          }
        } else {
          if (invitation_code) {
            try {
              let r = await check(invitation_code, wedding_code);
              wedding.set(r.data);
            } catch (e) {
              console.log(e);
              wedding.set(undefined);
              wedding_code = null;
              invitation_code = null;
            }

            if (invitation_code != r.data.code) {
              isJoined($wedding.guid)
                .then((r) => {
                  if (r.count == 0) {
                    join($wedding.guid, wedding_code, invitation_code).then(() => {
                      navigate(`#/wedding/${$wedding.guid}/A`);
                    });
                  } else {
                    navigate(`#/wedding/${$wedding.guid}/A`);
                  }
                })
                .catch((e) => {});
            } else {
              navigate(`#/wedding/${$wedding.guid}/A`);
            }
          } else {
            navigate(`#/select/${$lastWedding}`);
          }
        }
      })
      .catch(async (e) => {
        logged = false;

        if (invitation_code) {
          try {
            let r = await check(invitation_code, wedding_code);
            wedding.set(r.data);
            signup_step = 2;
            showSignUp.set(false);
            joinWedding = true;
          } catch (e) {
            console.log(e);
            wedding.set(undefined);
            wedding_code = null;
            invitation_code = null;

            signup_step = 1;
            showSignUp.set(false);
            if ($userLogin != "") {
              showLogin.set(true);
            }
          }
        } else {
          signup_step = 1;
          showSignUp.set(false);
          if ($userLogin != "") {
            showLogin.set(true);
          }
        }
      });
  });
</script>

{#if $showSignUp && canSignUp}
  <SignUp step={signup_step} user_email={email} on:close={onCloseSignUp} />
{/if}

{#if joinWedding && canJoin}
  <JoinWithSignUp
    step={signup_step}
    wedding={$wedding}
    code={invitation_code}
    {isLogin}
    bapteme={bapteme}
    on:close={() => (joinWedding = false)} />
{/if}

<div class="bannerContent">
  <div>
    <img class="logo" src="images/logo.svg" height="160px" alt="logo" />
  </div>
  <span>Faites de ce jour un moment unique...</span>
  {#if underConstruction}
    <div class="unavailable">
      <p>
        <i class="fa fa-exclamation-triangle" />
        <span>Site en construction</span>
      </p>
      <p>Bientôt disponible</p>
    </div>
  {:else}
    <button on:click={onCreateWedding}>
      Commençez
      <i class="fa fa-arrow-right" />
    </button>
    <button on:click={onJoinWedding} class="join">Rejoindre un mariage</button>
  {/if}
</div>

<style>
  .bannerContent {
    position: absolute;
    top: 0;
    left: 10%;
    background-color: rgba(255, 255, 255, 0.9);
    font-family: "Cinzel";
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-evenly;
    height: 100%;
  }

  @media (min-width: 1280px) and (max-width: 1560px) {
    .bannerContent {
      height: 99%;
    }
  }

  @media screen and (min-width: 980px) and (max-width: 1280px) {
    .bannerContent {
      height: 98.75%;
    }
  }

  @media (max-width: 980px) {
    .bannerContent {
      height: 98%;
    }
  }

  .bannerContent > div {
    width: 100%;
  }
  img.logo {
    margin: auto 1rem;
    height: 160px;
    top: 0;
    left: 0;
  }
  span {
    font-size: 1.5rem;
    color: var(--primary-color);
    padding: 0 1em;
  }
  button {
    font-family: "Cinzel";
    font-size: 1rem;
    font-weight: bold;
    color: #fff;
    background-color: var(--primary-color);
    cursor: pointer;
    border-radius: 5px;
    width: 60%;
    min-width: 230px;
    padding: 0.5rem;
  }
  button i {
    font-size: 1rem;
    margin-left: 10px;
  }
  button:hover {
    background-color: var(--primary-light-color);
  }
  button.join {
    color: var(--primary-dark-color);
    background-color: #fff;
    border-color: var(--primary-color);
  }
  button.join:hover {
    background-color: var(--primary-xx-light-gray-color);
  }

  @media screen and (max-width: 600px) {
    .bannerContent {
      background-color: #ffffff80;
      width: 100%;
      left: 0;
    }
  }

  .unavailable {
    background-color: rgb(141, 162, 133);
    color: white;
  }
  .unavailable p {
    display: flex;
    padding: 0 1em;
    align-items: center;
    justify-content: center;
  }
  .unavailable .fa {
    font-size: 5em;
    color: #e0d100;
  }
  .unavailable span {
    vertical-align: top;
    line-height: 3em;
    margin-left: 1em;
  }
</style>
